import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import { Units, Colors } from 'Css';
import classNames from 'classnames';
import Tooltip from 'components/Tooltip';

const css = oxygenCss({
  button: {
    padding: Units.base,
    // width: 24,
    height: 24,
    minWidth: 24,
    verticalAlign: 'middle',
    border: 'none',
    flex: '1 0 auto',
    cursor: 'pointer',
    backgroundColor: 'transparent',
    transition: 'background-color 0.25s ease',
    borderStyle: 'none none solid none',
    borderWidth: 2,
    borderColor: 'transparent',
    outline: 'none',
    textAlign: 'center',
    '&dense': {
      padding: 0
    },
    '&disabled': {
      cursor: 'default',
      backgroundColor: Colors.material.grey[300].hex,
      ':hover': {
        backgroundColor: Colors.material.grey[300].hex
      }
    },
    ':hover': {
      backgroundColor: Colors.material.grey[300].hex
    },
    '&active': {
      backgroundColor: Colors.material.grey[300].hex
    }
  }
});

class ToolbarButton extends Component {
  static propTypes = {
    tooltip: PropTypes.node,
    children: PropTypes.node,
    disabled: PropTypes.bool,
    dense: PropTypes.bool,
    onTouchTap: PropTypes.func,
    onBlur: PropTypes.func,
    className: PropTypes.string,
    selected: PropTypes.bool
  };

  state = {
    hover: false,
    active: false
  };

  componentDidMount() {
    this._node = ReactDOM.findDOMNode(this);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.disabled) {
      this.setState({ hover: false, active: false });
    }
  }

  getNode = () => {
    return ReactDOM.findDOMNode(this);
  };

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleMouseLeave = () => {
    this.setState({ hover: false });
  };

  handleFocus = () => {
    this.setState({ active: true });
  };

  handleBlur = () => {
    const { onBlur } = this.props;
    this.setState({ active: false });
    onBlur && onBlur();
  };

  handleTouchTap = event => {
    event.preventDefault();
    event.stopPropagation();
    const { onTouchTap, disabled } = this.props;
    if (!disabled && onTouchTap) {
      onTouchTap(...arguments);
    }
  };

  render() {
    const {
      className,
      dense,
      disabled,
      tooltip,
      children,
      ...other
    } = this.props;
    const { hover, active } = this.state;
    const classes = classNames(css.button, className, {
      [css.disabled]: disabled,
      [css.active]: active,
      [css.dense]: dense
    });
    const handlers = disabled
      ? {}
      : {
          onFocus: this.handleFocus,
          onBlur: this.handleBlur,
          onMouseEnter: this.handleMouseEnter,
          onMouseLeave: this.handleMouseLeave,
          onTouchTap: this.handleTouchTap
        };
    return (
      <button {...other} {...handlers} className={classes}>
        {children}
        {hover &&
          tooltip && <Tooltip anchorTo={this.getNode}>{tooltip}</Tooltip>}
      </button>
    );
  }
}

export default ToolbarButton;



// WEBPACK FOOTER //
// ./src/js/components/Toolbar/ToolbarButton.js